import { Home, TreePine, ShieldCheck, MessageSquare } from "lucide-react";
import { CoconutTree, Lighthouse } from "@/components/KonkanVectors";

const V = ({ children, className }) => (
  <div className={`absolute pointer-events-none select-none ${className}`} aria-hidden="true">{children}</div>
);

export const StatsStrip = ({ stats }) => (
  <section className="relative py-8 md:py-10 px-6 border-b border-border/30 overflow-hidden" data-testid="stats-section">
    <V className="-left-6 -top-4 w-28 md:w-44 opacity-[0.12]"><CoconutTree /></V>
    <V className="right-4 md:right-10 -top-2 w-14 md:w-20 opacity-[0.14]"><Lighthouse /></V>
    <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4">
      {[
        { icon: Home, val: `${stats.homestays}+`, label: "Homestays" },
        { icon: TreePine, val: `${stats.villages}+`, label: "Villages" },
        { icon: ShieldCheck, val: "Verified", label: "Properties" },
        { icon: MessageSquare, val: `${(1000 + (stats.inquiries || 0)).toLocaleString('en-IN')}+`, label: "Inquiries" },
      ].map((s, i) => (
        <div key={i} className="flex items-center gap-3 justify-center md:justify-start">
          <s.icon className="w-6 h-6 text-primary/70 flex-shrink-0" />
          <div>
            <span className="text-lg font-bold text-foreground">{s.val}</span>
            <p className="text-xs text-muted-foreground">{s.label}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
